var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBracesinline = function SvgBracesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#braces_inline_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "url(#braces_inline_svg__b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.387 46c-.794 0-1.516-.123-2.166-.368a6.33 6.33 0 0 1-1.75-.993 6.643 6.643 0 0 1-1.318-1.472 10.536 10.536 0 0 1-.92-1.803 11.07 11.07 0 0 1-.541-1.968 12.19 12.19 0 0 1-.163-1.968v-2.999c0-1.63-.373-2.802-1.118-3.513-.746-.712-1.883-1.067-3.411-1.067v-3.68c1.528 0 2.665-.355 3.41-1.066.746-.712 1.12-1.895 1.12-3.55v-3c0-.637.047-1.293.144-1.967.108-.675.276-1.331.505-1.969a9.028 9.028 0 0 1 .866-1.784 6.284 6.284 0 0 1 1.3-1.472 6.261 6.261 0 0 1 1.768-.993c.674-.245 1.431-.368 2.274-.368L24 12.888c-.734-.024-1.3.135-1.696.478-.397.332-.686.773-.866 1.325a7.183 7.183 0 0 0-.325 1.858 56.154 56.154 0 0 0-.036 2.005v2.998c0 1.46-.355 2.754-1.065 3.882-.698 1.128-1.786 1.986-3.266 2.575 1.492.589 2.586 1.441 3.284 2.557.698 1.116 1.047 2.404 1.047 3.863v2.999c0 .662.036 1.33.108 2.005a7.61 7.61 0 0 0 .451 1.858c.217.552.511.993.884 1.324.385.344.878.503 1.48.478L23.387 46ZM32.614 46c.794 0 1.515-.123 2.165-.368a6.33 6.33 0 0 0 1.75-.993 6.643 6.643 0 0 0 1.318-1.472c.36-.564.667-1.165.92-1.803.24-.637.421-1.293.541-1.968a12.19 12.19 0 0 0 .163-1.968v-2.999c0-1.63.373-2.802 1.119-3.513.745-.712 1.882-1.067 3.41-1.067v-3.68c-1.528 0-2.665-.355-3.41-1.066-.746-.712-1.12-1.895-1.12-3.55v-3c0-.637-.047-1.293-.144-1.967a10.985 10.985 0 0 0-.505-1.969 9.028 9.028 0 0 0-.866-1.784 6.284 6.284 0 0 0-1.3-1.472 6.261 6.261 0 0 0-1.768-.993c-.673-.245-1.431-.368-2.273-.368L32 12.888c.734-.024 1.3.135 1.696.478.397.332.686.773.866 1.325.18.552.29 1.171.325 1.858.024.674.036 1.343.036 2.005v2.998c0 1.46.355 2.754 1.065 3.882.698 1.128 1.786 1.986 3.266 2.575-1.492.589-2.586 1.441-3.284 2.557-.698 1.116-1.047 2.404-1.047 3.863v2.999c0 .662-.036 1.33-.108 2.005a7.61 7.61 0 0 1-.451 1.858c-.217.552-.511.993-.884 1.324-.385.344-.878.503-1.48.478L32.614 46Z",
    fill: "#181A1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "braces_inline_svg__a",
    x1: 56,
    y1: 0,
    x2: 0,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#F14AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#401AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "braces_inline_svg__b",
    x1: 56.025,
    y1: 0,
    x2: -1.103,
    y2: 1.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57F906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#00CCC0"
  })))));
};
export default SvgBracesinline;